import { render, staticRenderFns } from "./ManualCombineResultCard.vue?vue&type=template&id=71c7e26a"
import script from "./ManualCombineResultCard.vue?vue&type=script&lang=js"
export * from "./ManualCombineResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports